export const PublicRoute = ({ element }) => {
    return element;
};

